import { useEffect, useRef } from 'react'

const useEventListener = (eventName: string, handler:(e)=>void, element ,dep=[]) => {

  let savedHandler: any = useRef()
  useEffect(()=>{
    savedHandler.current =handler;
  },[handler]);

  useEffect(()=>{
      // 确认是否支持addEventListener
      const isSupported =element &&element.addEventListener;
      if(!isSupported)return;
      // 创建一个调用储存在ref中函数的事件监听
      const eventListener =event=>{
        event.preventDefault();
        savedHandler.current(event)
      };

      // 添加事件监听
      element.addEventListener(eventName,eventListener);

      // 在cleanup的回调中，清除事件监听

      return ()=>{
        element.removeEventListener(eventName,eventListener);
      };
    },
    [eventName,element,...dep]// 当元素或者绑定事件改变时，重新运行
  );
}
export default useEventListener
